import {formater} from '../formater/formater';

$(document).ready(function(){
 
  var format = new formater();
  var $fone                   =  $('#customer_phone_number');
  var $enterprise_cnpj         = $('#customer_cnpj'); 
  

  if ($enterprise_cnpj.value !== "" && $enterprise_cnpj.value !== "undefined"){
    var cnpj = document.getElementById('customer_cnpj');
    $enterprise_cnpj.keyup(function(){
      cnpj.value = format.applyMasc(cnpj.value,'cnpj')
    });
    $enterprise_cnpj.focusout(function(){
      cnpj.value = format.applyMasc(cnpj.value,'cnpj') 
    });
  };
   
  if ($fone.value !== "" && $fone.value !== "undefined" ){
    var tel = document.getElementById('customer_phone_number');
    $fone.keyup(function(){
      tel.value = format.applyMasc(tel.value,'tel');
    });
    $fone.focusout(function(){
      tel.value = format.applyMasc(tel.value,'tel');  
    });
  };
/*
  if ($mobile.val() !== ""){
    $mobile.keyup(function(){
      $mobile.val(format.applyMasc($mobile.val(),'tel'))  
    });
    $mobile.focusout(function(){
      $mobile.val(format.applyMasc($mobile.val(),'tel'))  
    });    
  };

  if ($cpf.val() !== ""){
    $cpf.keyup(function(){
      $cpf.val(format.applyMasc($cpf.val(),'cpf'))  
    });
    $cpf.focusout(function(){
      $cpf.val(format.applyMasc($cpf.val(),'cpf'))  
    });        
  };

  if ($cpf_field_search.val() !== ""){
    $cpf_field_search.keyup(function(){
      $cpf_field_search.val(format.applyMasc($cpf_field_search.val(),'cpf'))  
    });
    $cpf_field_search.focusout(function(){
      $cpf_field_search.val(format.applyMasc($cpf_field_search.val(),'cpf'))  
    });        
  };

  if ($zip_field.val() !== ""){
    $zip_field.keyup(function(){
      $zip_field.val(format.applyMasc($zip_field.val(),'zipcode'))  
    });
    $zip_field.focusout(function(){
      $zip_field.val(format.applyMasc($zip_field.val(),'zipcode'))  
    });        
  };
 */ 
/*
  $('#health_to_customer_health_insurance_id').change(function(){
    var valor = $('#health_to_customer_health_insurance_id').val();
    $.ajax({
      type: 'GET',
      url: 'health_insurance_plans',
      beforeSend: function(){
        $("#data").html('<div class="alert alert-info" role="alert">Carregando planos e produtos</div>');
      },
      data: {health_insurance_id: valor},
      success: function(msg){
        console.log(msg);
        $("#product_plan").html(msg);
      }
    })
  });
 */ 

});